// src/utils/truInkTemplate.js
import callPiggybackAPI from "../components/TruInk/Helpers/piggyback.api.helper";

// Generate signed URLs for file uploads
export const generateSignedUrls = async (fileNames, contentTypes) => {
  try {
    const response = await callPiggybackAPI(
      "templates/generate-upload-urls",
      {},
      {
        fileNames,
        contentTypes,
      },
      "POST"
    );
    return response;
  } catch (error) {
    console.error("Error generating signed URLs:", error);
    throw error;
  }
};

export const uploadImagesToGCS = async (formData) => {
  try {
    for (let [key, value] of formData.entries()) {
      if (value instanceof File || value instanceof Blob) {
        console.log(
          `${key}: ${value.name || "blob"} (${value.size} bytes, ${value.type})`
        );
      } else {
        console.log(`${key}: ${value}`);
      }
    }

    const response = await callPiggybackAPI(
      "templates/upload-images",
      {},
      formData,
      "POST"
    );

    return response.data;
  } catch (error) {
    console.error("Error uploading images:", error);

    if (error.response) {
      // Server responded with error status
      const message =
        error.response.data?.message ||
        `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      // Request was made but no response received
      throw new Error("Network error: No response from server");
    } else {
      // Something else happened
      throw new Error(`Upload error: ${error.message}`);
    }
  }
};

// Save new template
export const saveTemplate = async (templateData, tenantId, siteId) => {
  try {
    const payload = {
      ...templateData,
      tenantId: tenantId,
      siteId: siteId,
    };

    const response = await callPiggybackAPI("templates", {}, payload, "POST");

    return response.data;
  } catch (error) {
    console.error("Error saving template:", error);
    throw error;
  }
};

export const getCanvasFonts = async (tenantId, siteId) => {
  try {

    const params = {
      tenantId: tenantId
    };
    if (siteId) {
      params.siteId = siteId;
    }
    
    const response = await callPiggybackAPI(
      'canvasFonts',
      params,
      {},
      'GET'
    );
   

    return response;
  } catch (error) {
    console.error('Error fetching canvas fonts:', error);
    throw error;
  }
};

// Update template by ID
export const updateTemplate = async (
  templateData,
  templateId,
  tenantId,
  siteId
) => {
  try {
    const payload = {
      ...templateData,
      tenantId: tenantId,
      id: templateId,
      siteId: siteId,
    };

    const response = await callPiggybackAPI("templates", {}, payload, "POST");

    return response.data;
  } catch (error) {
    console.error("Error updating template:", error);
    throw error;
  }
};

//  Fetch template(s) - can fetch all templates for a tenant or a specific template
export const fetchTemplate = async (
  tenantId,
  templateId = null,
  siteId = null
) => {
  try {
    if (!tenantId || !siteId) {
      throw new Error('Template ID and Tenant ID are required');
    }


    // Build query parameters
    const queryParams = { tenantId };
    if (templateId) {
      queryParams.templateId = templateId;
    }
    if (siteId) {
      queryParams.siteId = siteId;
    }

    const response = await callPiggybackAPI(
      "templates",
      queryParams,
      {},
      "GET"
    );


    if (response.statusText && response.statusText !== "OK") {
      throw new Error(`Failed to fetch template: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("Error fetching template:", error);
    throw error;
  }
};

// Fetch canvas sizes
export const fetchCanvasSizes = async (tenantId) => {
  try {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    const response = await callPiggybackAPI(
      "canvasSize",
      { tenantId },
      {},
      "GET"
    );

    if (response.statusText && response.statusText !== "OK") {
      throw new Error(`Failed to fetch canvas sizes: ${response.statusText}`);
    }
    return response;
  } catch (error) {
    console.error("Error fetching canvas sizes:", error);
    throw error;
  }
};
export const fetchInternalConfigurations = async () => {
  try {
    const response = await callPiggybackAPI(
      "internalConfiguration",
      { configName: "dynamicConfig"},
      {},
      "GET"
    );
    
    if (response.statusText && response.statusText !== "OK") {
      throw new Error(`Failed to fetch internal configurations: ${response.statusText}`);
    }
    return response;
  } catch (error) {
    console.error("Error fetching canvas sizes:", error);
    throw error;
  }
};

// Fetch canvas colors
export const fetchCanvasColors = async (tenantId) => {
  try {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    const response = await callPiggybackAPI(
      "canvasColor",
      { tenantId },
      {},
      "GET"
    );
    if (response.statusText && response.statusText !== "OK") {
      throw new Error(`Failed to fetch canvas colors: ${response.statusText}`);
    }

    return response;
  } catch (error) {
    console.error("Error fetching canvas colors:", error);
    throw error;
  }
};

// Delete template
export const deleteTemplate = async (templateId, tenantId) => {
  try {
    if (!tenantId && !templateId) {
      throw new Error("Tenant ID and Template ID is required");
    }

    // Build query parameters
    const queryParams = { tenantId };
    if (templateId) {
      queryParams.templateId = templateId;
    }

    const response = await callPiggybackAPI(
      "templates",
      queryParams,
      {},
      "DELETE"
    );

    return response;
  } catch (error) {
    console.error("Error deleteing template: ", error);
    throw error;
  }
};

export async function fetchDataBindingValues(tenantId) {
  try {
    const response = await callPiggybackAPI(
      "data-info",
      { tenantId },
      {},
      "GET"
    );
   
    return response;
  } catch (error) {
    console.error("Error deleteing template: ", error);
    throw error;
  }
}
